// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"c3693555","660":"0921a8a4"}[chunkId] + ".chunk.js";
};